import { ShieldCheck, Globe2, Truck, BadgeDollarSign } from "lucide-react";
import SectionHeader from "./SectionHeader";
import { Card, CardContent } from "@/components/ui/card";

const REASONS = [
    {
        icon: ShieldCheck,
        title: "Vetted Supply Partners",
        desc: "Every brand and supplier we onboard is checked for authenticity, authorization and compliance — protecting your reputation and ours."
    },
    {
        icon: Globe2,
        title: "Cross-border Sourcing",
        desc: "Our focus is connecting US, GCC, European and Asian markets with the right brands, suppliers and procurement teams."
    },
    {
        icon: Truck,
        title: "Reliable Logistics",
        desc: "Coordinated freight, customs and warehousing through trusted partners — so shipments arrive on time, in spec, with full documentation."
    },
    {
        icon: BadgeDollarSign,
        title: "Transparent Pricing",
        desc: "No hidden fees or grey-market games. Clean invoicing, clear terms, and margins that work for long-term partnerships."
    }
];

export default function WhyChooseUs() {
    return (
        <section id="why" className="py-20 lg:py-28 bg-muted/40 border-y border-border">
            <div className="container-px mx-auto max-w-7xl">
                <SectionHeader
                    eyebrow="Why partner with us"
                    title="Built for serious B2B partners — not retail buyers."
                    description="We work with brand owners, distributors and procurement teams who need a wholesale partner that takes compliance, communication and delivery seriously — even as a new, founder-led operation."
                    align="center"
                />

                <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5">
                    {REASONS.map((r, idx) => (
                        <Card
                            key={r.title}
                            className="group relative flex flex-col bg-background border-border hover:border-primary/30 hover:shadow-soft transition-smooth"
                        >
                            <CardContent className="flex flex-col h-full p-6 lg:p-7">
                                <div className="flex items-center justify-between">
                                    <span className="grid place-items-center w-11 h-11 rounded-lg bg-accent text-accent-foreground border border-border">
                                        <r.icon className="w-5 h-5" />
                                    </span>
                                    <span className="font-display text-sm font-medium text-muted-foreground">
                                        0{idx + 1}
                                    </span>
                                </div>
                                <h3 className="mt-6 font-display text-lg font-semibold text-foreground leading-snug">
                                    {r.title}
                                </h3>
                                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                                    {r.desc}
                                </p>
                                <div className="mt-auto pt-6">
                                    <div className="h-px w-full bg-border group-hover:bg-primary/20 transition-smooth" />
                                </div>
                            </CardContent>
                        </Card>
                    ))}
                </div>
            </div>
        </section>
    );
}
